// Courses imported by the CMS sync carry bookkeeping lines in their description
// ("cms-slug: …", "cms-revision: …", a "seed:preply" marker). They are for the
// importer, not for learners.
const CMS_META_LINE = /^\s*cms-(slug|revision|status|hash):/;

export const visibleCourseDescription = (description: string): string =>
  description
    .split('\n')
    .filter(line => !CMS_META_LINE.test(line) && !line.includes('seed:preply'))
    .join('\n')
    .replace(/^\n+|\n+$/g, '');
